import { WindowOpen, borwserHistory, zenSigleton, } from '@zenlayer/portal-utils';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { parseUrlSearch } from '../../common/utils';
import { changeUrlByHistory, detailUrlParamsParse, detailUrlParamsStringify, generateURLQueryFromOptions, mergeUrlParamWithLocation, normalizeUrlPath, } from './util';
export { DetailDrawer } from './detail-drawer';
import '@zenlayer/zen-design-icons/assets/suggest/Close.svg';
export * from './events';
export { detailUrlParamsParse, detailUrlParamsStringify } from './util';
export function generateDetailURL(query, opts) {
    const urlQuery = generateURLQueryFromOptions(opts, true);
    const search = detailUrlParamsStringify(query || {}, urlQuery);
    const url = mergeUrlParamWithLocation({
        pathname: normalizeUrlPath(opts.path).url,
        search,
    }).toString();
    return url;
}
/**
 *
 * @param query
 * @param opts  i18nkey 面包屑 i18n，仅传入 t("xxfffd") 中的字符串，在运行时动态获取 i18n 中的文案
 * @param newWindow
 */
export function onOpenDetail(query, opts, newWindow) {
    const url = generateDetailURL(query, opts);
    if (newWindow) {
        new WindowOpen(url);
    }
    else {
        borwserHistory.push(url, {});
    }
}
export function onCloseDetail() {
    const detailDrawer = zenSigleton.get('detailDrawer');
    detailDrawer.close();
}
export function useDetailDrawer(opts) {
    const detailDrawer = zenSigleton.get('detailDrawer');
    const location = (opts?.useLocation || useLocation)();
    useEffect(() => {
        const urlQuery = parseUrlSearch(location.search);
        const query = detailUrlParamsParse(location.search);
        if (opts && urlQuery['addition_route']) {
            opts.query = query;
            opts.i18nKey = query['addition_i18nkey'] || opts.i18nKey;
            detailDrawer.open({ ...opts, histroyReplace: true });
        }
    }, []);
    return {
        close: detailDrawer.close,
        open: (query, option, newWindow) => {
            if (opts) {
                opts.query = query;
                const computedQuery = {
                    ...opts,
                    name: option?.name || '',
                    i18nKey: option?.i18nKey || (option?.name ? undefined : opts.i18nKey),
                };
                const purePath = normalizeUrlPath(opts.path).url;
                const urlQuery = generateURLQueryFromOptions(computedQuery, !!option?.fullScreen);
                const search = detailUrlParamsStringify(query || {}, urlQuery);
                if (newWindow) {
                    const url = mergeUrlParamWithLocation({
                        pathname: purePath,
                        search,
                    }).toString();
                    new WindowOpen(url);
                }
                else {
                    // 改变新传入的params,如果不改变会与open时
                    changeUrlByHistory({ search });
                    detailDrawer?.open({
                        ...opts,
                        path: purePath,
                        histroyReplace: true,
                    });
                }
            }
        },
    };
}
